//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** Represents the approval status for the Interactive Experience system. */
export const InteractiveExperienceApprovalStatus = {
    /** Answer is pending and has not been reviewed by a moderator. */
    Pending: 0,

    /** Answer has been approved by a moderator. */
    Approved: 1,

    /** Answer has been rejected by a moderator. */
    Rejected: 2
} as const;

/** Represents the approval status for the Interactive Experience system. */
export const InteractiveExperienceApprovalStatusDescription: Record<number, string> = {
    0: "Pending",

    1: "Approved",

    2: "Rejected"
};

/** Represents the approval status for the Interactive Experience system. */
export type InteractiveExperienceApprovalStatus = typeof InteractiveExperienceApprovalStatus[keyof typeof InteractiveExperienceApprovalStatus];
